import { Typography } from 'Components/atoms';
import { RiCompass3Fill } from '@react-icons/all-files/ri/RiCompass3Fill';
import React from 'react';
import { Image } from 'react-bootstrap';
import type { TargetFindingDisplayItem } from './targetFindingDisplay.util';

type TargetFindingsCellContentProps = {
  items: TargetFindingDisplayItem[];
};

export function TargetFindingListRow({ item }: { item: TargetFindingDisplayItem }) {
  return (
    <div className="ag-engagement-flow-grid__target-finding-row d-flex align-items-center gap-2 min-w-0">
      <div className="ag-engagement-flow-grid__target-finding-icon d-flex align-items-center gap-1 flex-shrink-0">
        {item.iconSrc ? (
          <Image src={item.iconSrc} width={14} height={17} alt="" />
        ) : null}
        {item.showMicrotrainingAccessory ? (
          <RiCompass3Fill className="ag-engagement-flow-grid__target-finding-accessory-icon" size={14} />
        ) : null}
      </div>
      <span
        className="ag-engagement-flow-grid__target-finding-label-wrap min-w-0 text-truncate"
        title={item.label}
      >
        <Typography
          variant="caption1"
          className="ag-engagement-flow-grid__target-finding-label text-uppercase mb-0"
        >
          {item.label}
        </Typography>
      </span>
    </div>
  );
}

const TargetFindingsCellContent: React.FC<TargetFindingsCellContentProps> = ({ items }) => {
  if (items.length === 0) {
    return <span className="bodyFont">-</span>;
  }

  return (
    <div className="ag-engagement-flow-grid__target-findings d-flex flex-column gap-1 py-1 w-100">
      {items.map((item) => (
        <TargetFindingListRow key={item.key} item={item} />
      ))}
    </div>
  );
};

export default TargetFindingsCellContent;
